import React from 'react';
import LinkToSectionScroll from 'components/LinkToSectionScroll/LinkToSectionScroll';
import { formatDataValue } from 'utils/formatFns';

export const rootLevelFields = {
  awrWeight: {
    label: 'AWR Weight',
    getValue: (data) => data?.awrWeight,
    formatValue: (value) => (value ? `${formatDataValue({ value })} LBS` : 'N/A'),
  },
  currentVdc: {
    label: 'Current VDC',
    getValue: (data) => data?.currentVdcLocationCd,
    formatValue: (value) => formatDataValue({ value }),
  },
  empty: {
    label: '',
    getValue: () => '',
    formatValue: () => '',
  },
  inventoryCode: {
    label: 'Inventory Code',
    getValue: (data) => data?.inventoryTypeCd,
    formatValue: (value) => value || null,
    tooltipText: 'Logistics Inventory Code',
  },
  inWorkpool: {
    label: 'In Workpool',
    getValue: (data) => data?.inventoryTypeCd,
    formatValue: (value) => (value?.toLowerCase() === 'b9' ? 'In Workpool' : 'Not In Workpool'),
  },
  katashikiLogistics: {
    label: 'Katashiki',
    getValue: (data) => data?.katashikiCd,
    formatValue: (value) => formatDataValue({ value }),
  },
  originalEstBuildDate: {
    label: 'Original Est. Build Date',
    getValue: (data) => data?.originalEstBuildDtFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  originalScheduledDate: {
    label: 'Original Scheduled Date',
    getValue: (data) => data?.accySvcOrgnSchdlProcessDtFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  originalVdc: {
    label: 'Original VDC',
    getValue: (data) => data?.originalVdcLocationCd,
    formatValue: (value) => formatDataValue({ value }),
  },
  plantId: {
    label: 'Plant ID',
    getValue: (data) => data?.plantId,
    formatValue: (value) => formatDataValue({ value }),
  },
  ppoCount: {
    label: 'PPO Count',
    getValue: (data) => data?.ppoCount,
    formatValue: (value) => formatDataValue({ value }),
  },
  preFreezeDate: {
    label: 'Pre-Freeze Date',
    getValue: (data) => data?.preFreezeDtFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  processByDate: {
    label: 'Process By Date',
    getValue: (data) => data?.accySvcProcessByDtFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  pTagPrintDate: {
    label: 'P-Tag Print Date',
    getValue: (data) => data?.ptagPrintDtTsFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  simNumber: {
    label: 'SIM Number',
    getValue: (data) => data?.simNbr,
    formatValue: (value) => formatDataValue({ value }),
  },
  stagingLocation: {
    label: 'Staging Location',
    getValue: (data) => data?.railStageNbr,
    formatValue: (value) => formatDataValue({ value }),
  },
  tmsOrderNumber: {
    label: 'TMS Order Number',
    getValue: (data) => data?.orderNbr,
    formatValue: (value) => formatDataValue({ value }),
  },
  transmissionNumberLogistics: {
    label: 'Transmission Number',
    getValue: (data) => data?.transmissionNbr,
    formatValue: (value) => formatDataValue({ value }),
  },
  truckawayPoint: {
    label: 'Truckaway Point',
    getValue: (data) => data?.truckawayPoint,
    formatValue: (value) => formatDataValue({ value }),
  },
  vehicleJourneyLink: {
    label: 'More Detailed History',
    getValue: () => null,
    formatValue: () => <LinkToSectionScroll label="Transportation" scrollToId="transportation" />,
  },
  vin: {
    label: 'VIN',
    getValue: (data) => data?.vin,
    formatValue: (value) => formatDataValue({ value }),
    withCopyIcon: true,
  },
  xmRadioNumberLogistics: {
    label: 'XM Radio Number',
    getValue: (data) => data?.xmRadioId,
    formatValue: (value) => formatDataValue({ value }),
  },
};
